<template>
  <div class='forgot_wrap'>
    <div class="table_container">
      <h1>Reset your password</h1>
      <div class="new_p">
        <input type="password" placeholder="New Password" autocomplete="off" v-model.trim="password" @focus="focus_on = true; init = true" @blur="focus_on = false">
        <div class="notice" v-show="show_off">
          <p :class="getClass('type1')">8 to 25 characters</p>
          <p :class="getClass('type2')">Upper & lowercase letters</p>
          <p :class="getClass('type3')">At least one number</p>
          <p :class="getClass('type4')">Can not use special numeric except !@#$%^&*()?<>._-</p>
        </div>
      </div>
      <div class="confirm">
        <input type="password" placeholder="Confirm Password" autocomplete="off" v-model.trim='rpassword' @blur="check_rcode">
        <div v-show="init_status.rule3" class="notice wrong">{{notice.words_3}}</div>
      </div>
      <div class="clearfix btns">
        <p class="service_words" v-show='service_show'>{{service_words}}</p>
        <a class='continue' @click='next_reset'>Continue</a>
        <a class="cancel" @click='back_login'>Cancel</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      init: false, // 0为刚刚初始化，没有进行任何操作，否则置为false
      focus_on: false,
      user_email: '',
      rpassword: '',
      password: '',
      init_status: {
        rule3: ''
      },
      notice: {
        words_3: ''
      },
      service_show: '',
      service_words: ''
    }
  },
  methods: {
    check_rcode: function() {
      if (!this.rpassword) {
        this.notice.words_3 = "Please don't leave Your retyped password blank!."
        this.init_status.rule3 = true
      } else if (this.rpassword != this.password) {
        this.notice.words_3 = "The password you retyped doesn't match."
        this.init_status.rule3 = true
      } else {
        this.init_status.rule3 = false
      }
    },
    next_reset: function() {
      let _this = this
      this.init = true
      this.check_rcode()
      let rule =
        this.passwordCheck.checkStatus &&
        this.init_status.rule3 == false

      if (!rule) return

      let params = new URLSearchParams()

      let checkCode = window.localStorage.c_c ? window.localStorage.c_c : ''

      params.append('email', _this.user_email)

      params.append('password', _this.password)

      params.append('re_password', _this.rpassword)

      params.append('code', checkCode)

      this.axios
        .post('/index/resetpwd', params)
        .then(function(response) {
          if (response && response.data.code == '75000') {
            //_this.$router.push('fillform')
            _this.service_show = false

            _this.$router.push('forgot_password_step4')
          } else {
            _this.service_words = response.data.message

            _this.service_show = true
          }
        })
    },
    back_login: function() {
      this.$router.go(-1)
    },

    getClass(type) {
      let passwordCheck = this.passwordCheck
      if (passwordCheck.empty) return 'remind_normal'
      
      if (passwordCheck[type]) {
        return 'remind_pass'
      }

      return 'remind_wrong'
    }
  },
  computed: {
    show_off: function() {
      if (!this.init) return
      if (!this.focus_on && this.passwordCheck.checkStatus) return

      return true
    },

    passwordCheck() {
      let password = this.password
      let empty = password === ''
      let type1 = password.length >= 8 && password.length <= 25
      let type2 =
        password.search(/[a-z]/) > -1 && password.search(/[A-Z]/) > -1
      let type3 = password.search(/[0-9]/) > -1
      let type4 = /^[A-Za-z0-9\!\@\#\$\%\^\&\*\(\)\?\<\>\._-]*$/.test(password)
      
      return {
        type1,
        type2,
        type3,
        type4,
        checkStatus: type1 && type2 && type3 && type4,
        empty
      }
    }
  },
  beforeRouteEnter: function(from, to, next) {
    let params_arrys = []
    let prams_c = []
    next(vm => {
      if (window.localStorage.r_email) {
        vm.user_email = window.localStorage.r_email
      } else {
        try {
          params_arrys = window.location.href.split('?')[1]
          prams_c = params_arrys.split('&')
          for (let arr of prams_c) {
            if (arr.split('=')[0] == 'email') {
              vm.user_email = arr.split('=')[1]
            }
          }
        } catch (e) {}
      }
    })
  }
}
</script>

<style lang='less' scoped>
.forgot_wrap {
  height: 1000px;
  background: url('~@img/creat_acount_bg.jpg') no-repeat center
    center;
  .table_container {
    width: 366px;
    margin: 0 auto;
    padding-top: 255px;
    div.notice {
      position: absolute;
      left: 370px;
      top: 50%;
      transform: translateY(-60%);
      padding-left: 20px;
      width: 290px;
      line-height: 15px;
      font-size: 13px;
      color: #ffffff;
      white-space: nowrap;
      // background: url('~@img/dot_remind.png') no-repeat 0 center;
      p {
        padding-left: 14px;
        line-height: 14px;
        margin-bottom: 5px;
        text-indent: 0.5em;
        background: url('~@img/notice_icons.png') no-repeat 0 0;
      }

      .remind_normal {
        background-position: 0 0;
        color: #c4c4c4;
      }
      .remind_pass {
        background-position: 0 -14px;
        color: #31cd7b;
      }
      .remind_wrong {
        background-position: 0 -28px;
        color: #fd4e4e;
      }
    }
    div.wrong {
      // background: url('~@img/dot_wrong.png') no-repeat 0 center;
      color: #ff3434;
    }
    h1 {
      text-align: center;
      color: #ffffff;
      font-size: 38px;
    }
    p {
      font-size: 15px;
      line-height: 20px;
    }
    p.notice {
      margin-top: 44px;
      color: #999999;
      span {
        color: #febf00;
      }
    }
    p.wrong {
      position: relative;
      padding-left: 26px;
      margin-top: 5px;
      color: #fe0036;
      span {
        position: absolute;
        left: 0;
        top: 0;
        width: 20px;
        height: 19px;
        background: url('~@img/forgot_step_1.png') no-repeat 0 0;
      }
    }
    div.new_p,
    div.confirm {
      position: relative;
      margin-top: 23px;
      input {
        background: transparent url('~@img/forgot_step_1.png')
          no-repeat 0 -40px;
        box-sizing: border-box;
        padding: 2px 0 13px 33px;
        outline: none;
        width: 100%;
        border-bottom: 1px solid #868685;
        color: #fff;
      }
    }

    div.btns {
      position: relative;
      padding-top: 47px;
      .service_words {
        position: absolute;
        left: 0;
        top: 10px;
        color: #ff3434;
        font-size: 13px;
        line-height: 13px;
      }
      a {
        float: left;
        cursor: pointer;
        width: 170px;
        height: 46px;
        line-height: 46px;
        font-size: 24px;
        text-align: center;
        border-radius: 50px;
        background: #ffc000;
        color: #000000;
      }
      a.cancel {
        border: 1px solid #ffc000;
        background: transparent;
        color: #ffc000;
        margin-left: 19px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// forgot_password_step3.vue?09e3f242